import { render, staticRenderFns } from "./ApplicationsTab.vue?vue&type=template&id=6d4a0a18&scoped=true"
import script from "./ApplicationsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationsTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ApplicationsTab.vue?vue&type=style&index=0&id=6d4a0a18&prod&scoped=true&lang=scss"
import style1 from "./ApplicationsTab.vue?vue&type=style&index=1&id=6d4a0a18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a0a18",
  null
  
)

export default component.exports